module.exports = __FOREMAN_VENDOR__ACE_BUILDS_SRC_MIN_NOCONFLICT_EXT_SEARCHBOX__;